<template>
  <div class="mini-app-theme-container">
    <!--面包屑导航区域-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>小程序主题管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 操作按钮 -->
    <div class="operation-bar">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">
        新增主题
      </el-button>
      <el-button type="success" icon="el-icon-refresh" @click="handleRefresh">
        刷新
      </el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
        v-loading="loading"
        :data="themeList"
        border
        stripe
        style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="80" align="center">
      </el-table-column>

      <el-table-column prop="name" label="主题名称" width="150" align="center">
      </el-table-column>

      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'">
            {{ scope.row.status === '1' ? '激活' : '失效' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="导航图标" align="center">
        <template slot-scope="scope">
          <div class="icon-preview">
            <img v-if="scope.row.homeIcon" :src="ossURL+scope.row.homeIcon" alt="首页" class="icon-img" title="首页图标">
            <img v-if="scope.row.homeSelectedIcon" :src="ossURL+scope.row.homeSelectedIcon" alt="首页" class="icon-img" title="首页选中图标">
            <img v-if="scope.row.coachIcon" :src="ossURL+scope.row.coachIcon" alt="助教" class="icon-img" title="助教图标">
            <img v-if="scope.row.coachSelectedIcon" :src="ossURL+scope.row.coachSelectedIcon" alt="助教" class="icon-img" title="助教选中图标">
            <img v-if="scope.row.dzIcon" :src="ossURL+scope.row.dzIcon" alt="动作" class="icon-img" title="动作图标">
            <img v-if="scope.row.dzSelectedIcon" :src="ossURL+scope.row.dzSelectedIcon" alt="动作" class="icon-img" title="动作选中图标">
            <img v-if="scope.row.myIcon" :src="ossURL+scope.row.myIcon" alt="我的" class="icon-img" title="我的图标">
            <img v-if="scope.row.mySelectedIcon" :src="ossURL+scope.row.mySelectedIcon" alt="我的" class="icon-img" title="我的选中图标">
          </div>
        </template>
      </el-table-column>

      <el-table-column label="首页功能" align="center">
        <template slot-scope="scope">
          <div class="function-preview">
            <img v-if="scope.row.tghx" :src="ossURL+scope.row.tghx" alt="团购核销" class="function-img" title="团购核销">
            <img v-if="scope.row.ddzy" :src="ossURL+scope.row.ddzy" alt="到店指引" class="function-img" title="到店指引">
            <img v-if="scope.row.storeQx" :src="ossURL+scope.row.storeQx" alt="门店器械" class="function-img" title="门店器械">
            <img v-if="scope.row.openStore" :src="ossURL+scope.row.openStore" alt="我要开店" class="function-img" title="我要开店">
<!--            <img v-if="scope.row.onlineKf" :src="ossURL+scope.row.onlineKf" alt="在线客服" class="function-img" title="在线客服">-->
            <img v-if="scope.row.memberBak" :src="ossURL+scope.row.memberBak" alt="会员卡背景" class="function-img" title="会员卡背景">
            <img v-if="scope.row.avar" :src="ossURL+scope.row.avar" alt="头像图标" class="function-img" title="头像图标">
            <img v-if="scope.row.videoCon" :src="ossURL+scope.row.videoCon" alt="监控背景" class="function-img" title="监控背景">
            <img v-if="scope.row.videoWd" :src="ossURL+scope.row.videoWd" alt="监控温度" class="function-img" title="监控温度">
            <img v-if="scope.row.videoSd" :src="ossURL+scope.row.videoSd" alt="监控湿度" class="function-img" title="监控湿度">
            <img v-if="scope.row.notice" :src="ossURL+scope.row.notice" alt="通知图标" class="function-img" title="通知图标">
            <img v-if="scope.row.homeLightArrow" :src="ossURL+scope.row.homeLightArrow" alt="右箭头" class="function-img" title="右箭头">
          </div>
        </template>
      </el-table-column>

      <el-table-column label="教练功能" align="center">
        <template slot-scope="scope">
          <div class="function-preview">
            <img v-if="scope.row.coachBak" :src="ossURL+scope.row.coachBak" alt="教练背景" class="function-img" title="教练背景">
          </div>
        </template>
      </el-table-column>

      <el-table-column label="我的功能" align="center">
        <template slot-scope="scope">
          <div class="function-preview">
            <img v-if="scope.row.myBak" :src="ossURL+scope.row.myBak" alt="背景图" class="function-img" title="背景图">
            <img v-if="scope.row.olineBuyCard" :src="ossURL+scope.row.olineBuyCard" alt="在线购卡" class="function-img" title="在线购卡">
            <img v-if="scope.row.inFace" :src="ossURL+scope.row.inFace" alt="录入人脸" class="function-img" title="录入人脸">
            <img v-if="scope.row.wifiPass" :src="ossURL+scope.row.wifiPass" alt="WIFI密码" class="function-img" title="WIFI密码">
            <img v-if="scope.row.storeLog" :src="ossURL+scope.row.storeLog" alt="到店记录" class="function-img" title="到店记录">
            <img v-if="scope.row.srtx" :src="ossURL+scope.row.srtx" alt="收入提现" class="function-img" title="收入提现">
            <img v-if="scope.row.lyService" :src="ossURL+scope.row.lyService" alt="淋浴服务" class="function-img" title="淋浴服务">
            <img v-if="scope.row.myly" :src="ossURL+scope.row.myly" alt="我要留言" class="function-img" title="我要留言">
            <img v-if="scope.row.qxbx" :src="ossURL+scope.row.qxbx" alt="器械报修" class="function-img" title="器械报修">
            <img v-if="scope.row.kf" :src="ossURL+scope.row.kf" alt="24h客服" class="function-img" title="24h客服">
            <img v-if="scope.row.cwCoach" :src="ossURL+scope.row.cwCoach" alt="成为教练" class="function-img" title="成为教练">
            <img v-if="scope.row.reserveLog" :src="ossURL+scope.row.reserveLog" alt="预约记录" class="function-img" title="预约记录">
            <img v-if="scope.row.logout" :src="ossURL+scope.row.logout" alt="退出登录" class="function-img" title="退出登录">
            <img v-if="scope.row.storeMiner" :src="ossURL+scope.row.storeMiner" alt="我是店主" class="function-img" title="我是店主">
            <img v-if="scope.row.coachMiner" :src="ossURL+scope.row.coachMiner" alt="我是助教" class="function-img" title="我是助教">
            <img v-if="scope.row.tgVerify" :src="ossURL+scope.row.tgVerify" alt="团购验券" class="function-img" title="团购验券">
          </div>
        </template>
      </el-table-column>

      <el-table-column label="背景颜色" width="100" align="center">
        <template slot-scope="scope">
          <div
              v-if="scope.row.bakColor"
              class="color-preview"
              :style="{ backgroundColor: scope.row.bakColor }"
              :title="scope.row.bakColor"
          >
          </div>
        </template>
      </el-table-column>

      <el-table-column label="按钮颜色" width="100" align="center">
        <template slot-scope="scope">
          <div
              v-if="scope.row.btnColor"
              class="color-preview"
              :style="{ backgroundColor: scope.row.btnColor }"
              :title="scope.row.btnColor"
          >
          </div>
        </template>
      </el-table-column>

      <el-table-column label="文字颜色" width="100" align="center">
        <template slot-scope="scope">
          <div
              v-if="scope.row.textColor"
              class="color-preview"
              :style="{ backgroundColor: scope.row.textColor }"
              :title="scope.row.textColor"
          >
          </div>
        </template>
      </el-table-column>

      <el-table-column label="边框背景" width="100" align="center">
        <template slot-scope="scope">
          <div
              v-if="scope.row.containBak"
              class="color-preview"
              :style="{ background: scope.row.containBak }"
              :title="scope.row.containBak"
          >
          </div>
        </template>
      </el-table-column>

      <el-table-column label="监控文字" width="100" align="center">
        <template slot-scope="scope">
          <div
              v-if="scope.row.videoColor"
              class="color-preview"
              :style="{ backgroundColor: scope.row.videoColor }"
              :title="scope.row.videoColor"
          >
          </div>
        </template>
      </el-table-column>

      <el-table-column label="动作选中" width="100" align="center">
        <template slot-scope="scope">
          <div
              v-if="scope.row.dzSelected"
              class="color-preview"
              :style="{ backgroundColor: scope.row.dzSelected }"
              :title="scope.row.dzSelected"
          >
          </div>
        </template>
      </el-table-column>

      <el-table-column label="有效时间"  align="center">
        <template slot-scope="{row}">
          <span v-if="row.startDate">{{row.startDate}} ~ {{row.endDate}}</span>
          <span v-else>永久有效</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
          >
            编辑
          </el-button>
          <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加/编辑对话框 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="80%"
        :close-on-click-modal="false"
    >
      <el-form
          ref="themeForm"
          :model="themeForm"
          :rules="themeRules"
          label-width="150px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="主题名称" prop="name">
              <el-input
                  v-model="themeForm.name"
                  placeholder="请输入主题名称"
                  clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--            <el-form-item label="状态" prop="status">-->
            <!--              <el-select v-model="themeForm.status" placeholder="请选择状态">-->
            <!--                <el-option label="激活" value="1"></el-option>-->
            <!--                <el-option label="失效" value="0"></el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item label="有效时间" prop="startDate">
              <el-date-picker
                  v-model="validDate"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 颜色配置 -->
        <el-divider content-position="left">颜色配置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="按钮颜色">
              <el-color-picker
                  v-model="themeForm.btnColor"
                  show-alpha
                  :predefine="predefineColors"
              ></el-color-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="文字颜色">
              <el-color-picker
                  v-model="themeForm.textColor"
                  show-alpha
                  :predefine="predefineColors"
              ></el-color-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="首页背景色">
              <el-color-picker
                  v-model="themeForm.bakColor"
                  show-alpha
                  :predefine="predefineColors"
              ></el-color-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="监控文字颜色">
              <el-color-picker
                  v-model="themeForm.videoColor"
                  show-alpha
                  :predefine="predefineColors"
              ></el-color-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="动作菜单选中色">
              <el-color-picker
                  v-model="themeForm.dzSelected"
                  show-alpha
                  :predefine="predefineColors"
              ></el-color-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首页边框背景色">
              <gradient-color-picker
                  v-model="themeForm.containBak"
              ></gradient-color-picker>
            </el-form-item>
          </el-col>
        </el-row>


        <!-- 导航图标配置 -->
        <el-divider content-position="left">导航图标配置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="首页图标">
              <el-upload
                  ref="homeIconUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.homeIcon"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'homeIcon'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首页选中图标">
              <el-upload
                  ref="homeSelectedIconUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.homeSelectedIcon"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'homeSelectedIcon'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="助教图标">
              <el-upload
                  ref="coachIconUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.coachIcon"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'coachIcon'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="助教选中图标">
              <el-upload
                  ref="coachSelectedIconUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.coachSelectedIcon"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'coachSelectedIcon'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="动作图标">
              <el-upload
                  ref="dzIconUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.dzIcon"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'dzIcon'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="动作选中图标">
              <el-upload
                  ref="dzSelectedIconUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.dzSelectedIcon"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'dzSelectedIcon'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="我的图标">
              <el-upload
                  ref="myIconUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.myIcon"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'myIcon'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="我的选中图标">
              <el-upload
                  ref="mySelectedIconUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.mySelectedIcon"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'mySelectedIcon'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 首页功能配置 -->
        <el-divider content-position="left">首页功能配置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="团购核销">
              <el-upload
                  ref="tghxUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.tghx"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'tghx'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到店指引">
              <el-upload
                  ref="ddzyUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.ddzy"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'ddzy'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="门店器械">
              <el-upload
                  ref="storeQxUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.storeQx"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'storeQx'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="我要开店">
              <el-upload
                  ref="openStoreUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.openStore"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'openStore'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="会员卡背景">
              <el-upload
                  ref="memberBakUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.memberBak"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'memberBak'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员卡卡背景">
              <el-upload
                  ref="memberItemUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.memberItem"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'memberItem'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="在线客服">
              <el-upload
                  ref="onlineKfUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.onlineKf"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'onlineKf'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="头像">
              <el-upload
                  ref="avarUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.avar"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'avar'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="监控背景">
              <el-upload
                  ref="videoConUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.videoCon"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'videoCon'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="监控温度">
              <el-upload
                  ref="videoWdUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.videoWd"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'videoWd'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="监控湿度">
              <el-upload
                  ref="videoSdUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.videoSd"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'videoSd'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通知图标">
              <el-upload
                  ref="noticeUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.notice"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'notice'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="首页右箭头">
              <el-upload
                  ref="homeLightArrowUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.homeLightArrow"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'homeLightArrow'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 助教配置 -->
        <el-divider content-position="left">助教配置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="助教背景">
              <el-upload
                  ref="coachBakUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.coachBak"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'coachBak'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>


        <!-- 我的功能配置 -->
        <el-divider content-position="left">我的功能配置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="在线购卡">
              <el-upload
                  ref="tghxUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.olineBuyCard"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'olineBuyCard'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="录入人脸">
              <el-upload
                  ref="ddzyUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.inFace"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'inFace'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="WIFI密码">
              <el-upload
                  ref="tghxUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.wifiPass"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'wifiPass'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到店记录">
              <el-upload
                  ref="ddzyUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.storeLog"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'storeLog'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="我要留言">
              <el-upload
                  ref="tghxUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.myly"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'myly'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="器械报修">
              <el-upload
                  ref="ddzyUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.qxbx"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'qxbx'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="24h客服">
              <el-upload
                  ref="tghxUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.kf"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'kf'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成为教练">
              <el-upload
                  ref="ddzyUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.cwCoach"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'cwCoach'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="我是教练">
              <el-upload
                  ref="tghxUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.coachMiner"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'coachMiner'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="我是店主">
              <el-upload
                  ref="ddzyUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.storeMiner"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'storeMiner'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="预约记录">
              <el-upload
                  ref="tghxUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.reserveLog"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'reserveLog'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="退出登录">
              <el-upload
                  ref="ddzyUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.logout"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'logout'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收入提现">
              <el-upload
                  ref="srtxUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.srtx"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'srtx'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="淋浴服务">
              <el-upload
                  ref="lyServiceUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.lyService"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'lyService'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="删除人脸">
              <el-upload
                  ref="delFaceUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.delFace"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'delFace'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保洁开门">
              <el-upload
                  ref="bjOpenUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.bjOpen"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'bjOpen'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邀请好友">
              <el-upload
                  ref="yqFriendUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.yqFriend"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'yqFriend'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进店指南">
              <el-upload
                  ref="jdznUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.jdzn"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'jdzn'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="团购验券">
              <el-upload
                  ref="tgVerifyUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.tgVerify"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'tgVerify'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="背景图片">
              <el-upload
                  ref="myBakUpload"
                  :limit="1"
                  :auto-upload="true"
                  :file-list="picMap.myBak"
                  :on-success="uploadPic"
                  :on-remove="delPic"
                  :data="{label: 'myBak'}"
                  list-type="picture-card"
                  accept="image/*"
                  :action="uploadurl">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">
          {{ isEdit ? '更 新' : '新 增' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import GradientColorPicker from '../common/GradientColorPicker.vue'

export default {
  name: 'MiniAppTheme',
  components: {
    GradientColorPicker
  },
  data() {
    return {
      validDate: [],
      ossURL: this.ossURL,
      // 表格数据
      themeList: [],
      loading: false,

      // 对话框相关
      dialogVisible: false,
      dialogTitle: '新增主题',
      isEdit: false,
      submitLoading: false,

      uploadurl: this.GLOBAL.imgURL+'uploadThemeIcon/',

      // 表单对应的图片上传组件
      picMap:{
        homeIcon:[],
        homeSelectedIcon:[],
        coachIcon:[],
        coachSelectedIcon:[],
        dzIcon:[],
        dzSelectedIcon:[],
        myIcon:[],
        mySelectedIcon:[],
        tghx:[],
        ddzy:[],
        storeQx:[],
        openStore:[],
        onlineKf:[],
        memberBak:[],
        olineBuyCard:[],
        inFace:[],
        wifiPass:[],
        storeLog:[],
        myly:[],
        qxbx:[],
        kf:[],
        cwCoach:[],
        reserveLog:[],
        logout:[],
        coachMiner:[],
        memberItem:[],
        storeMiner:[],
        srtx:[],
        lyService:[],
        delFace:[],
        bjOpen:[],
        yqFriend:[],
        jdzn:[],
        avar:[],
        videoCon: [],
        videoWd: [],
        videoSd: [],
        notice: [],
        coachBak: [],
        homeLightArrow: [],
        tgVerify: [],
        myBak: []
      },

      // 表单数据
      themeForm: {
        id: null,
        name: '',
        status: '1',
        homeIcon: '',
        homeSelectedIcon: '',
        coachIcon: '',
        coachSelectedIcon: '',
        dzIcon: '',
        dzSelectedIcon: '',
        myIcon: '',
        mySelectedIcon: '',
        tghx: '',
        ddzy: '',
        storeQx: '',
        openStore: '',
        onlineKf: '',
        memberBak: '',
        olineBuyCard: '',
        inFace: '',
        wifiPass: '',
        storeLog: '',
        myly: '',
        qxbx: '',
        kf: '',
        cwCoach: '',
        reserveLog: '',
        logout: '',
        avar: '',
        storeMiner: '',
        coachMiner: '',
        memberItem: '',
        srtx:'',
        lyService:'',
        delFace:'',
        bjOpen:'',
        yqFriend:'',
        jdzn:'',
        startDate: '',
        endDate: '',
        btnColor: '#409EFF',
        bakColor: '#409EFF',
        textColor: '#000000',
        videoCon: '',
        videoColor: '#000000',
        videoWd: '',
        videoSd: '',
        notice: '',
        containBak: '#FFFFFF',
        coachBak: '',
        dzSelected: '#fef5f2',
        tgVerify: '',
        homeLightArrow: '',
        myBak: ''
      },

      // 表单验证规则
      themeRules: {
        name: [
          { required: true, message: '请输入主题名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },

      // 预定义颜色
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        '#409EFF',
        '#67C23A',
        '#E6A23C',
        '#F56C6C',
        '#909399'
      ]
    }
  },

  mounted() {
    this.loadThemeList()
  },

  methods: {
    /**
     * 加载主题列表
     */
    async loadThemeList() {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('mini-app-theme/')
        if (res.status === 0) {
          this.themeList = res.data || []
        } else {
          this.$message.error(res.msg || '获取主题列表失败')
        }
      } catch (error) {
        console.error('获取主题列表失败:', error)
        this.$message.error('获取主题列表失败')
      } finally {
        this.loading = false
      }
    },

    /**
     * 刷新列表
     */
    handleRefresh() {
      this.loadThemeList()
    },

    /**
     * 新增主题
     */
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增主题'
      this.resetForm()
      this.dialogVisible = true
    },

    /**
     * 编辑主题
     */
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑主题'
      this.themeForm = { ...row }

      Object.keys(this.themeForm).forEach(key => {
        if (this.themeForm[key]) {
          this.picMap[key] = [{name:this.themeForm[key],url:this.ossURL+this.themeForm[key]}]
        }
      })
      if (row.startDate) {
        this.validDate = [new Date(row.startDate), new Date(row.endDate)]
      }
      this.dialogVisible = true
    },

    /**
     * 删除主题
     */
    handleDelete(row) {
      this.$confirm(`确定要删除主题"${row.name}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data: res } = await this.$http.delete(`mini-app-theme/${row.id}`)
          if (res.status === 0) {
            this.$message.success('删除成功')
            this.loadThemeList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    /**
     * 提交表单
     */
    handleSubmit() {
      this.$refs.themeForm.validate(async (valid) => {
        if (!valid) {
          return false
        }

        this.submitLoading = true
        try {
          let url = 'mini-app-theme/'
          let method = 'post'

          if (this.isEdit) {
            url = `mini-app-theme/update`
            method = 'put'
          }

          if(this.validDate && this.validDate.length > 0) {
            this.themeForm.startDate = this.validDate[0]
            this.themeForm.endDate = this.validDate[1]
          }

          const { data: res } = await this.$http[method](url, this.themeForm)

          if (res.status === 0) {
            this.$message.success(this.isEdit ? '更新成功' : '新增成功')
            this.dialogVisible = false
            this.loadThemeList()
          } else {
            this.$message.error(res.msg || (this.isEdit ? '更新失败' : '新增失败'))
          }
        } catch (error) {
          console.error('提交失败:', error)
          this.$message.error(this.isEdit ? '更新失败' : '新增失败')
        } finally {
          this.submitLoading = false
        }
      })
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.validDate = []
      this.themeForm = {
        id: null,
        name: '',
        status: '1',
        homeIcon: '',
        homeSelectedIcon: '',
        coachIcon: '',
        coachSelectedIcon: '',
        dzIcon: '',
        dzSelectedIcon: '',
        myIcon: '',
        mySelectedIcon: '',
        tghx: '',
        ddzy: '',
        storeQx: '',
        openStore: '',
        onlineKf: '',
        memberBak: '',
        olineBuyCard: '',
        inFace: '',
        wifiPass: '',
        storeLog: '',
        myly: '',
        qxbx: '',
        kf: '',
        cwCoach: '',
        reserveLog: '',
        logout: '',
        avar: '',
        coachMiner: '',
        storeMiner: '',
        memberItem: '',
        srtx:'',
        lyService:'',
        delFace:'',
        bjOpen:'',
        yqFriend:'',
        jdzn:'',
        startDate: '',
        endDate: '',
        btnColor: '#409EFF',
        bakColor: '#409EFF',
        textColor: '#000000',
        videoCon: '',
        videoColor: '#000000',
        videoWd: '',
        videoSd: '',
        notice: '',
        containBak: '#FFFFFF',
        coachBak: '',
        dzSelected: '#fef5f2',
        tgVerify: '',
        myBak: ''
      }

      this.picMap = {
        homeIcon:[],
        homeSelectIcon:[],
        coachIcon:[],
        coachSelectedIcon:[],
        dzIcon:[],
        dzSelectedIcon:[],
        myIcon:[],
        mySelectedIcon:[],
        tghx:[],
        ddzy:[],
        storeQx:[],
        openStore:[],
        onlineKf:[],
        memberBak:[],
        olineBuyCard:[],
        inFace:[],
        wifiPass:[],
        storeLog:[],
        myly:[],
        qxbx:[],
        kf:[],
        cwCoach:[],
        reserveLog:[],
        avar:[],
        storeMiner:[],
        coachMiner:[],
        memberItem:[],
        srtx:[],
        lyService:[],
        delFace:[],
        bjOpen:[],
        yqFriend:[],
        jdzn:[],
        logout:[],
        videoCon: [],
        videoWd: [],
        videoSd: [],
        notice: [],
        coachBak: [],
        tgVerify: []
      }

      if (this.$refs.themeForm) {
        this.$refs.themeForm.resetFields()
      }
    },
    uploadPic(file){
      if (file.code == '0') {
        this.$message({message: '上传成功！',type: 'success'})
        this.themeForm[file.label] = file.url
      } else {
        this.picMap[file.label] = []
        this.$message({message: file.msg,type: 'error'})
      }
    },
    delPic(file){
      Object.keys(this.themeForm).forEach(key => {
        if (this.themeForm[key] !== null && this.themeForm[key] == file.name) {
          this.themeForm[key] = null
          this.picMap[key] = []
        }
      })
    }
  }
}
</script>

<style scoped>
.mini-app-theme-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
}

.operation-bar {
  margin-bottom: 20px;
}

.icon-preview {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
}

.icon-img {
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 4px;
}

.function-preview {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.function-img {
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 4px;
}

.color-preview {
  width: 80px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  text-shadow: 1px 1px 1px rgba(0,0,0,0.5);
  margin: 0 auto;
}

.dialog-footer {
  text-align: right;
}

.el-divider {
  margin: 20px 0;
}
</style>
